import React, { Component } from 'react';
import { useEffect } from "react";
import { useState } from 'react';
import axios from 'axios';
import { variables } from '../Variables';
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import mindfreeLogo from '../assets/images/login_Logo.svg';

export const ValidateRemoveEvent = () => {

    const { agentId, estateId, clientId, language } = useParams();

    const [selectedLanguageTranslations, setSelectedLanguageTranslations] = useState(null);
    const [estatePurposeStatus, setEstatePurposeStatus] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [estatePusposeStatusJobDetail, setEstatePusposeStatusJobDetail] = useState(null);
    const [agentLanguage, setAgentLanguage] = useState("");
    const isOfficeLink = agentId != null && agentId.startsWith("office-");
    const displayId = isOfficeLink ? agentId.replace("office-", "") : agentId;

    // get agent from local db
    const getSpecificAgentDetailFromLocalDB = async () => {
        try {
            setIsLoading(true);
            let url = `${variables.API_URL}Estate/GetAgentById?agentId=${agentId}`;
            const jsonconfig = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            };

            const response = await axios.get(url, jsonconfig);
            if (response.data) {
                let agentLanguage = language || response.data.language || "fr-BE";
                setAgentLanguage(agentLanguage);
                getLanguageTranslations(agentLanguage);
            }
        } catch (error) {
            console.log(error);
            setEstatePurposeStatus("api error");
            setIsLoading(false);
        }
    }

    const getLanguageTranslations = async (agentLanguage) => {
        try {
            setIsLoading(true);
            const url = variables.API_URL + `Settings/GetTranslationsForSiteByLang?siteName=agent`;
            const jsonconfig = {
                headers: {
                    'Content-Type': 'application/json'
                }
            };

            const response = await axios.get(url, jsonconfig) // ASP.NET Core API endpoint with headers
            if (response.data) {
                let translations = response.data;
                if (Object.keys(translations).length > 0) {
                    let agentTranslation = translations[agentLanguage];
                    setSelectedLanguageTranslations(agentTranslation);

                    // check estate status from local db
                    checkEstatePurposeStatusJobFromLocalDB();
                }
            }
        } catch (error) {
            console.log(error);
            setEstatePurposeStatus("api error");
            setIsLoading(false);
        }
    }

    const checkEstatePurposeStatusJobFromLocalDB = async () => {
        
        try {
            setIsLoading(true);
            let url = `${variables.API_URL}LocalEvents/GetPurposeStatusChangeDetailById?purposeStatusJobId=${estateId}`;

            const jsonconfig = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            };

            const response = await axios.get(url, jsonconfig);
            if (response.data) {

                if (response.data.data == undefined && response.data.message == "Purpose Status Change Job value not available in DB") {
                    setEstatePurposeStatus("notexit");
                    setIsLoading(false);
                    return;
                }

                const expiryTime = new Date(response.data.data.expiryDateTime).getTime();
                const currentTime = new Date().getTime();

                if (response.data.data.jobStatus == "Enqueue" && currentTime > expiryTime) {
                    setEstatePusposeStatusJobDetail(response.data.data);
                    setEstatePurposeStatus("service expired");
                    setIsLoading(false);
                    return;
                }

                setEstatePurposeStatus(response.data.data.jobStatus);
                setEstatePusposeStatusJobDetail(response.data.data);
                setIsLoading(false);

            }
        } catch (error) {
            console.log(error);
            setEstatePurposeStatus("api error");
            setIsLoading(false);
        }
    }

    const takeActionOnEstatePurposeStatusJob = async () => {
        try {
            setIsLoading(true);
            let url = `${variables.API_URL}LocalEvents/abortPurposeStatusJob`;

            const jsonconfig = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            };
            const idToStore = isOfficeLink ? agentId.replace("office-", "") : agentId;
            const body = {
                "purposeStatusJobId": estateId,
                "abortAgentId": idToStore
            }

            const response = await axios.post(url, body, jsonconfig);
            if (response.data) {
                console.log(response.data);
                setEstatePurposeStatus("success completed");
                setIsLoading(false);
            }
        } catch (error) {
            console.log(error);
            setEstatePurposeStatus("api error");
            setIsLoading(false);
        }
    }

    const closePage = () => {
        window.close();
    }

    const getWhiseToken = async () => {
        setIsLoading(true);
        let url = "https://mink-mtsi-api.net7.be/api/User/GetWhiseTokenPerApp?appName=smartCal";
        let headers = {
            'Content-Type': 'application/json'
        };

        try {
            let resp = await axios.post(url, {},
                {
                    headers: headers
                });
            if (resp && resp.data && resp.data.token) {
                getClientSetting(resp.data.token);
            }
        }
        catch (e) {
            console.log(e);
        }
    }
    const WHISE_LANGUAGE_MAP = {
        1: "en-GB",
        2: "fr-BE",
        3: "nl-BE"
        // apni actual mapping confirm kar ke yahan values set karein
    };
    const getClientSetting = async (token) => {
        try {
            let url = 'https://api.whise.eu/v1/admin/clients/settings';

            const jsonConfig = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            }

            let body = {
                ClientId: clientId
            };

            const response = await axios.post(url, body, jsonConfig);
            if (response.data.settings) {
                let langId = response.data.settings.defaultLanguageId;
                let mappedLang = language || WHISE_LANGUAGE_MAP[langId] || "fr-BE"; // safe fallback
                setAgentLanguage(mappedLang);          // ab agentLanguage bhi properly set hoga
                getLanguageTranslations(mappedLang);
                //getLanguageTranslations(response.data.settings.defaultLanguageId);
            }
        } catch (error) {
            console.log("error", error);
        }
    }

    useEffect(() => {
        
        if (isOfficeLink)
        {
            // agent nahi, office flow — direct whise token/client settings se translations le lo
            getWhiseToken();
        }
        else if (agentId != null && agentId != "null") {
            
            getSpecificAgentDetailFromLocalDB();
        } else {
            getWhiseToken();
        }
    }, []);

    const formattedDateTime = (time) => {
        let formatDateTime = new Date(time)
            .toLocaleString(agentLanguage, {
                day: "2-digit",
                month: "short",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
            });
        return formatDateTime;
    }



    return (
        <>
            <div className="d-flex flex-column align-items-center justify-content-center" style={{ height: "100vh" }}>
                <img src={mindfreeLogo} className="mb-4 pb-5" alt="mindfree logo" />
                {
                    isLoading ?
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        //<h6 className={`fw-bold mt-4 ${selectedLanguageTranslations != null && isLoading == false ? "d-block" : "d-none"}`}>{selectedLanguageTranslations != null ? selectedLanguageTranslations["processingChoiceMsg"] : "Working on it! We’re processing your choice—hang tight and please don't close this window just yet."}</h6>
                        :
                        <div>
                            {
                                estatePurposeStatus == "Enqueue" ?
                                    <>
                                        <h6 className="fw-bold mb-4">{selectedLanguageTranslations ? selectedLanguageTranslations["doYouWantToTakeAction"] : "Do you want to take action?"}</h6>
                                        <div className="text-center">
                                            <button className="sm-accept-pg-btn site-btn-red site-btn-padd me-3 mb-3" onClick={closePage}>{selectedLanguageTranslations ? selectedLanguageTranslations["settingsPageNoRadioLbl"] : "No"}</button>
                                            <button className="sm-accept-pg-btn site-btn site-btn-padd mb-3" onClick={takeActionOnEstatePurposeStatusJob}>{selectedLanguageTranslations ? selectedLanguageTranslations["settingsPageYesRadioLbl"] : "Yes"}</button>
                                        </div>
                                    </>
                                    : estatePurposeStatus == "inProgress" ?
                                        <>
                                            <h6 className="fw-bold mb-4">{selectedLanguageTranslations ? selectedLanguageTranslations["requestedActionAlreadyProcessed"] : "An automatic process is currently running for your job."}</h6>
                                            <div className="d-flex justify-content-center">
                                                <button className="site-btn-padd close-page-btn w-75" onClick={closePage}>{selectedLanguageTranslations != null ? selectedLanguageTranslations["eventDenialPageSuccessScreenCloseButtonText"] : "Close this page"}</button>
                                            </div>
                                        </>
                                        : estatePurposeStatus == "completed" ?
                                            <>
                                                <h6 className="fw-bold mb-4">{selectedLanguageTranslations ? selectedLanguageTranslations["requestAlreadyInProgress"] : "This request is already being processed."} {estatePusposeStatusJobDetail != null ? formattedDateTime(estatePusposeStatusJobDetail.processedDateTime) : ""}</h6>
                                                <div className="d-flex justify-content-center">
                                                    <button className="site-btn-padd close-page-btn w-75" onClick={closePage}>{selectedLanguageTranslations != null ? selectedLanguageTranslations["eventDenialPageSuccessScreenCloseButtonText"] : "Close this page"}</button>
                                                </div>
                                            </>
                                            //: estatePurposeStatus == "Abort" ?
                                            //    <>
                                            //        <h6 className="fw-bold mb-4">{selectedLanguageTranslations ? selectedLanguageTranslations["confirmSlotModalAgentText"] : "Agent"} {agentId} {selectedLanguageTranslations ? selectedLanguageTranslations["requestSuccessfullyCompleted"] : "has already aborted this job at"} {estatePusposeStatusJobDetail != null ? formattedDateTime(estatePusposeStatusJobDetail.abortTime) : ""}</h6>
                                            //        <div className="d-flex justify-content-center">
                                            //            <button className="site-btn-padd close-page-btn w-75" onClick={closePage}>{selectedLanguageTranslations != null ? selectedLanguageTranslations["eventDenialPageSuccessScreenCloseButtonText"] : "Close this page"}</button>
                                            //        </div>
                                            //    </>
                                            : estatePurposeStatus == "Abort" ?
                                                <>
                                                    <h6 className="fw-bold mb-4">
                                                        {isOfficeLink
                                                            ? (selectedLanguageTranslations ? selectedLanguageTranslations["confirmSlotModalOfficeText"] : "Office")
                                                            : (selectedLanguageTranslations ? selectedLanguageTranslations["confirmSlotModalAgentText"] : "Agent")
                                                        } {displayId} {selectedLanguageTranslations ? selectedLanguageTranslations["requestSuccessfullyCompleted"] : "has already aborted this job at"} {estatePusposeStatusJobDetail != null ? formattedDateTime(estatePusposeStatusJobDetail.abortTime) : ""}
                                                    </h6>
                                                    <div className="d-flex justify-content-center">
                                                        <button className="site-btn-padd close-page-btn w-75" onClick={closePage}>{selectedLanguageTranslations != null ? selectedLanguageTranslations["eventDenialPageSuccessScreenCloseButtonText"] : "Close this page"}</button>
                                                    </div>
                                                </>
                                                : estatePurposeStatus == "success completed" ?
                                                    <>
                                                        <h6 className="fw-bold px-5 mb-4">{selectedLanguageTranslations ? selectedLanguageTranslations["databaseUpdatedSuccessfullyProceedManually"] : "Your database has been updated successfully. You may now proceed manually."}</h6>
                                                        <div className="d-flex justify-content-center">
                                                            <button className="site-btn-padd close-page-btn w-75" onClick={closePage}>{selectedLanguageTranslations != null ? selectedLanguageTranslations["eventDenialPageSuccessScreenCloseButtonText"] : "Close this page"}</button>
                                                        </div>
                                                    </>
                                                    : estatePurposeStatus == "service expired" ?
                                                        <>
                                                            <h6 className="fw-bold px-5 mb-4">{selectedLanguageTranslations ? selectedLanguageTranslations["serviceNoLongerAvailableExpiredJob"] : "The abort time has expired. The automatic process will resume shortly."}</h6>
                                                            <div className="d-flex justify-content-center">
                                                                <button className="site-btn-padd close-page-btn w-75" onClick={closePage}>{selectedLanguageTranslations != null ? selectedLanguageTranslations["eventDenialPageSuccessScreenCloseButtonText"] : "Close this page"}</button>
                                                            </div>
                                                        </>
                                                        : estatePurposeStatus == "notexit" ?
                                                            <>
                                                                <h6 className="fw-bold px-5 mb-4">{selectedLanguageTranslations ? selectedLanguageTranslations["requestNotExistInDatabase"] : "This request is not exist in the database."}</h6>
                                                                <div className="d-flex justify-content-center">
                                                                    <button className="site-btn-padd close-page-btn w-75" onClick={closePage}>{selectedLanguageTranslations != null ? selectedLanguageTranslations["eventDenialPageSuccessScreenCloseButtonText"] : "Close this page"}</button>
                                                                </div>
                                                            </>
                                                            :
                                                            <>
                                                                <h6 className="fw-bold px-5 mb-4">{selectedLanguageTranslations ? selectedLanguageTranslations["serverSideTechnicalIssues"] : "We will handle any technical issues on the server side."}</h6>
                                                                <div className="d-flex justify-content-center">
                                                                    <button className="site-btn-padd close-page-btn w-75" onClick={closePage}>{selectedLanguageTranslations != null ? selectedLanguageTranslations["eventDenialPageSuccessScreenCloseButtonText"] : "Close this page"}</button>
                                                                </div>
                                                            </>
                            }
                        </div>
                }
            </div>
        </>
    );

}

